import { z } from 'zod';
export const updateWorkRegionSelectionSchema = z.object({
    postalCodes: z.array(z.string()),
});
export const workRegionSelectionSchema = z.object({
    postalCodes: z.array(z.string()),
    cantonIds: z.array(z.string()),
});
